// Compact countdowns for the Take Over toasts (GRAVY-10443): "12h", "5h 40m",
// "40m". Computed against the caller's clock at the moment a toast is raised,
// never taken from the server, so "starts in" is not frozen at the instant the
// poll answered.

const MINUTE_MS = 60_000;

/** "5h 40m" / "12h" / "40m" for a positive span; null once it has elapsed. */
export const formatSpan = (ms: number): string | null => {
  if (ms <= 0) return null;
  const totalMinutes = Math.ceil(ms / MINUTE_MS);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h === 0) return `${m}m`;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
};

/** Whole minutes until `iso`, rounded up and never below zero. */
export const minutesUntil = (iso: string, now: number = Date.now()): number =>
  Math.max(0, Math.ceil((new Date(iso).getTime() - now) / MINUTE_MS));

/** "5h 40m" until the shift starts, or null once it has started. */
export const startsIn = (
  startsAt: string | null | undefined,
  now: number = Date.now(),
): string | null =>
  startsAt ? formatSpan(new Date(startsAt).getTime() - now) : null;
